import React from 'react';
export default function SummaryCards({summary}){
  const s=summary||{};
  return <div className="pub-summary">
    <div className="pub-box"><span>Normal Shift</span><strong className="shift">{s.normalShift||'—'}</strong></div>
    <div className="pub-box"><span>Direct Impact Periods</span><strong>{s.impactPeriods||0}</strong></div>
    <div className="pub-box"><span>Periods w/ Backfill</span><strong>{s.periodsWithBackfill||0}</strong></div>
    <div className="pub-box"><span>Periods w/o Backfill</span><strong>{s.periodsWithoutBackfill||0}</strong></div>
  </div>;
}
